export default __webpack_public_path__ + "static/media/41.f38fcfd2.png";